(function () {
    angular
        .module('checklistModule', [])
        .run(['$location', '$state', 'pubSub', 'documentService', 'tabStateService', '$rootScope', function ($location, $state, pubSub, documentService, tabStateService, $rootScope) {
            window.addEventListener("message", (event) => {
                if (!event.data || event.data.moduleName != 'checklist' || !event.data.eventName)
                    return;

                let backendRoute = '';
                switch (event.data.eventName) {
                    case 'checklist-route-change':

                        let frontendRoute = event.data.value.toLowerCase();
                        if (frontendRoute.indexOf('checklist/home') > -1) {
                            backendRoute = '/checklist-fe/home';
                        } else {
                            backendRoute = '/checklist-fe/' + frontendRoute;
                        }
                       
                        break;
                    
                    default:
                        backendRoute = '/';
                }

                if (!backendRoute) return;

                let url = $location.url();
                if (url === backendRoute) return;
                if (backendRoute.indexOf('?isHideTopbar') > -1) {
                    backendRoute = backendRoute.substring(0, backendRoute.indexOf('?isHideTopbar'));
                }
                if (!history.state || !history.state.id || (history.state.id !== backendRoute)) {
                    history.pushState({}, backendRoute, backendRoute);
                    //window.dispatchEvent(new PopStateEvent('popstate', {
                    //    state: history.state
                    //}));
                }
            });
        }]);
})();